import(/* webpackMode: "eager" */ "/codebuild/output/src2604469770/src/apps/web/app/[locale]/error.tsx");
